/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the platform-server/testing package.
 */
export * from './mock_backend';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
